(ns app.front.view.contractor-registration.view
  (:require [app.domain.util :as du]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.separator :as ui-sep]
            [app.front.ui.termination-info :as termination-info]
            [app.front.util :refer [for-frag]]
            [app.front.view.common.applications-section :as app-section]
            [app.front.view.common.data-grid :as dg]
            [app.front.view.common.generic-licence :as gl-view]
            [app.front.view.common.link :as common-link]
            [app.front.view.contractor-registration.subs :as cr-subs]
            [app.front.view.not-found :as not-found]
            [app.front.view.permit.download :as permit-download]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [>evt <sub]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]))

(defn contractor-registration-status
  [tr {:contractor-registration/keys [revocation-letter-document-generating? revocation-letter-document] :domain/keys [state]}]
  [dg/grid-item-tall
   (tr [:contractor-registration/status])
   [:<>
    [:div.pb-2 (tr [state])]
    (when revocation-letter-document-generating?
      [:div (cc/inline-loading {:description (tr [:licence/generating-revocation-letter-document])})])
    (when revocation-letter-document
      [file-download/download-file-link
       revocation-letter-document
       {:command :file/download-letter-file}])]])

(defn date-box [{:keys [group-tz date title]}]
  (when date
    (let [format-date (<sub [::date-util/date-fn])]
      [dg/grid-item-tall title [:div (format-date (date-util/to-tz date group-tz))]])))

(defn removed-trades-warning [tr removed-trade-names]
  (when (seq removed-trade-names)
    [ui/warning
     {:class "mb-8"}
     (str (tr [:contractor-registration/removed-trades-warning])
          " " (str/join ", " removed-trade-names))]))

(defn view [_]
  (let [tr                      (<sub [::cr-subs/tr])
        lang                    (<sub [:language])
        not-found?              (<sub [::cr-subs/not-found?])
        contractor-registration (<sub [::cr-subs/contractor-registration])
        registrant              (-> contractor-registration :contractor-registration/registrant)
        registrant-names        (-> contractor-registration :contractor-registration/registrant-names)
        trades                  (<sub [::cr-subs/registration-trade-names-sorted])
        group-tz                (-> contractor-registration :domain/authority-group :group/tz)
        valid-from              (-> contractor-registration :contractor-registration/valid-from)
        valid-to                (-> contractor-registration :contractor-registration/valid-to)
        admin?                  (<sub [:session/admin?])
        removed-trade-names     (<sub [::cr-subs/trades-with-removed-work-type])]

    [:div.cloudpermit-page
     (if not-found?
       [not-found/not-found-view]
       [:<>
        (when admin?
          [removed-trades-warning tr removed-trade-names])
        [:div.mb-8
         [:div.flex.flew-row.content-center.items-center
          [:h4 (tr [:contractor-registration/contractor-registration])]]
         [:div.my-2
          [:h2 (i18n-model/get-text-from-entities-or-map registrant-names lang)]]
         [permit-download/download-button
          (util/mmap {:verdict (:contractor-registration/verdict contractor-registration)} tr)]
         (when (eu/is-type? :entity.type/business registrant)
           [:div.mt-6 (cc/button
                        {:kind             :primary
                         :size             :small
                         :icon             i/arrow-right
                         :icon-description (tr [:contractor-registration/go-to-business-view])
                         :href             (href/href :view/business {:business-id (:db/id registrant)})
                         :data-cy          "go-to-business-view-btn"}
                        (tr [:contractor-registration/go-to-business-view]))])

         [ui-sep/horizontal]

         [dg/data-grid
          [contractor-registration-status tr contractor-registration]
          [dg/grid-item-tall
           (tr [:verdict.section.type/issued-to])
           [common-link/link-or-text lang registrant registrant-names]]
          [date-box (util/mmap {:title (tr [:verdict/issue-date])
                                :date  (-> contractor-registration
                                           :contractor-registration/verdict
                                           :verdict/issue-date)}
                               group-tz)]
          [date-box (util/mmap {:title (tr [:licence/valid-from])
                                :date  valid-from}
                               group-tz)]
          [date-box (util/mmap {:title (tr [:verdict/expiry-date])
                                :date  valid-to}
                               group-tz)]]

         [gl-view/renewal-box
          {:entity              contractor-registration
           :expired-state       :contractor-registration.state/expired
           :primary-signal-opts {:signal-id   :process.signal/renew-registration
                                 :process-sub [::cr-subs/current-entity-process]
                                 :button-opts {:kind    :tertiary
                                               :data-cy "renew-registration-button"}}
           :tr                  tr}]]

        (when (du/in-state? :contractor-registration.state/revoked contractor-registration)
          [termination-info/termination-info
           contractor-registration
           (util/mmap {:reason-attr  :contractor-registration/revocation-reason
                       :by-attr      :contractor-registration/revocation-by
                       :ts-attr      :contractor-registration/revocation-ts
                       :descr-tr-key :rejection/by} tr)])

        [:div.mt-6.flex.gap-2.flex-wrap
         (for-frag [trade trades]
           [:span
            [ui/small-pill
             {:uppercase? false :size :medium}
             trade]])]

        [app-section/applications tr (:contractor-registration/workspaces contractor-registration)]])]))

(defn business-breadcrumb []
  (let [lang                    (<sub [:language])
        contractor-registration (<sub [::cr-subs/contractor-registration])
        registrant              (-> contractor-registration :contractor-registration/registrant)
        registrant-names        (-> contractor-registration :contractor-registration/registrant-names)]
    (when (eu/is-type? :entity.type/business registrant)
      [:view/business
       {:business-id (:db/id registrant)}
       (i18n-model/get-text-from-entities-or-map registrant-names lang)])))

(defn breadcrumb [{:keys [match]}]
  (let [tr     (<sub [::cr-subs/tr])
        params (-> match :parameters :path)]
    [:view/contractor-registration params (tr [:contractor-registration/contractor-registration])]))

(def route
  {:name        :view/contractor-registration
   :view        view
   :view-sub    [::cr-subs/view-data]
   :breadcrumb  {:items [business-breadcrumb
                         breadcrumb]}
   :controllers [{:parameters {:path [:group-id :cr-id]}
                  :start      (fn [{{:keys [cr-id]} :path}]
                                (>evt [::cr-subs/fetch-contractor-registration cr-id]))}]})
